import React from "react";

const hindiTexts = [
  "सुरक्षित और आरामदायक वातावरण",
  "24x7 सुरक्षा और निगरानी",
  "स्वादिष्ट और पौष्टिक भोजन",
  "कुशल प्रबंधन और सुविधाएं",
  "छात्राओं के लिए एक आदर्श स्थान",
];

function HindiSlider() {
  return (
    <div className="bg-yellow-100 py-4 overflow-hidden">
      <div className="whitespace-nowrap animate-marquee text-lg font-medium text-red-700">
        {hindiTexts.map((text, index) => (
          <span key={index} className="mx-8">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}

export default HindiSlider;
